import { http } from "@canvas/api";

export interface InventoryUpdateReq {
  endpoint: "ragnarok.swatch.v1.inventory.:inventoryId.update";
  body: InventoryUpdateBody;
}

export interface InventoryUpdateBody {
  inventory_id: number;
  data: object;
}

export interface InventoryUpdateRes {}

export function put(req: InventoryUpdateReq): Promise<InventoryUpdateRes> {
  return http
    .PUT(
      `/ragnarok/swatch/v1/inventory/${req.body.inventory_id}`,
      req.body.data,
      { 'Content-Type': 'application/json' }
    )
    .then((response: InventoryUpdateRes) => {
      // validate response here
      return response;
    });
}
